import { createContext, useContext } from "react";

export type PageContextType = {
  countryCode: string;
  partial: boolean;
  pageId: string;
  pageType: string;
  searchClientURL: string;
  pageData: unknown;
  pagePreference: Record<string, unknown>;
  updatePagePreference: (storageKey: string, storageValue: unknown) => void;
};

export const PageContext = createContext<PageContextType | null>(null);

export const usePageData = () => {
  const context = useContext(PageContext);

  if (!context)
    throw new Error("usePageData must be used within a PageContext.Provider");

  return context;
};
